(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_';
    const LINE_ITEM_PROPS_REGEXP = /(?<=\[).+?(?=\])/;

    customElements.define('product-form', class extends Core {

        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        }

        render() {
            if (!this.$formTargeter) return; 
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
        }

        async _submitHandler(e) {
            e.preventDefault();

            const data = new FormData(this.$form);

            const quantityInputs = document.querySelectorAll('.product-buy-with-qty-input');
            quantityInputs.forEach(input => {
                const checkbox = input.closest('.product-buy-with-qty-wrapper')?.querySelector('input[type="checkbox"]');
                if (checkbox && checkbox.checked) {
                    const variantId = input.id.replace('qty-input-', '');
                    const quantity = parseInt(input.value, 10) || 1;
                    data.append(`quantity_${variantId}`, quantity);
                }
            });

            console.log('Updated FormData with all quantities:', Array.from(data.entries())); // Debugging line

            const cartItems = this.cartItems;

            const aggregatedSecondaryProducts = new Map(); // To track and aggregate secondary products by variant ID

            for (let cartItem of cartItems) {
                try {
                    const secondaryProducts = await handleSecondaryProductLogic({ variantId: cartItem.id }, cartItem.quantity);
                    
                    if (secondaryProducts && secondaryProducts.length > 0) {
                        for (let secondaryProduct of secondaryProducts) {
                            if (aggregatedSecondaryProducts.has(secondaryProduct.id)) {
                                aggregatedSecondaryProducts.set(
                                    secondaryProduct.id,
                                    aggregatedSecondaryProducts.get(secondaryProduct.id) + secondaryProduct.quantity
                                );
                            } else {
                                aggregatedSecondaryProducts.set(secondaryProduct.id, secondaryProduct.quantity);
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error calculating secondary products for cart item:", error);
                }
            }

            const aggregatedSecondaryProductsArray = Array.from(aggregatedSecondaryProducts, ([id, quantity]) => ({ id, quantity }));
            
            if (aggregatedSecondaryProductsArray.length > 0) {
                cartItems.push(...aggregatedSecondaryProductsArray);
            }

            console.log('Cart Items before adding to the cart:', cartItems); // Debugging line
            this.$toCartButton.addToCart(cartItems);
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id' || inputName.startsWith('quantity_');
        }
        
        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([ inputName, value ], index) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';
            let quantity = 1;

            if (inputName.startsWith('quantity_')) {
                quantity = parseInt(value, 10) || 1;
            } else if (inputName === 'id') {
                quantity = this.qty[index] || 1;
            } else if (inputName.includes(PREFIX_BUY_WITH)) {
                const quantityInput = document.querySelector(`#qty-input-${value}`);
                if (quantityInput) {
                    quantity = parseInt(quantityInput.value, 10) || 1;
                }
            }

            const cartItem = {
                id: value,
                quantity: quantity,
                selling_plan: inputName === 'id' ? sellingPlanId : '',
                properties: this._getProperties(inputName)
            };
            console.log('Setting cart item:', cartItem);
            return cartItem;
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }
        
        _getProperties(inputName) {
            return inputName === 'id' ? this.properties : {};
        }

        get cartItems() {
            const items = Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this));
            console.log('Cart Items:', items);
            return items;
        }

        get formData() {
            const data = new FormData(this.$form);
            console.log('FormData:', Array.from(data.entries()));
            return data;
        }

        get qty() {
            const quantities = this.formData.getAll('quantity').map(qty => +qty || 1);
            console.log('Quantities:', quantities);
            return quantities;
        }

        get properties() {
            return Array.from(this.formData.entries()).reduce((acc, [key, val]) => {
                if (key.startsWith('properties[') && key.endsWith(']') && val) {
                    const propKey = key.match(LINE_ITEM_PROPS_REGEXP)[0];
                    acc[propKey] = val;
                }
                return acc;
            }, {});
        }
    })
})();
